import React, {useEffect} from 'react';
import {useRouter} from "next/router";

type Props = {}

export default function Page({}: Props) {
	const router = useRouter();

	// redirect to /not-found?redirect_back = get router back

	useEffect(() => {
		const thisPath = router.asPath;
		const referrer = document.referrer && new URL(document.referrer).pathname;

		const isSame = thisPath == referrer || (thisPath.length > 0 && referrer.length > 0 && (Math.max(0, referrer.length - thisPath.length) >= 2) && thisPath.includes(referrer));

		router.push({
			pathname: '/not-found',
			query: {
				redirect_back: !isSame ? document.referrer : null,
				from: router.asPath || '/'
			}
		});
	}, []);

	return <div>
	</div>
};